<template>
  <div
    :data-testid="$testIds.app.root"
    :data-loader-count="$store.state.ui.showLoaderCount"
  >
    <router-view v-if="$store.state.settings.tenantSetting"></router-view>
    <loader v-if="$store.state.ui.showLoaderCount>0"></loader>
  </div>
</template>
<script>

import Loader from '@/components/Loader';
import accountService from '@/services/account.service';
import tenantService from '@/services/tenant.service';
import effectiveLanguageMixin from '@/utils/effectiveLanguageMixin';

export default {
  mixins: [effectiveLanguageMixin],
  components: { Loader },
  async created() {
    this.$store.commit('changeAPIURL', process.env.VUE_APP_API_URL);

    // Check authentication
    const userDataCookies = this.$cookies.get('userData');
    if (userDataCookies) {
      this.$store.commit('changeUserData', userDataCookies);
    }

    if (this.$store.state.auth.userData) {
      // Apply locale from userData before any redirect so screens like
      // force-change-password don't flash in the wrong language.
      this.applyEffectiveLanguage();
      if (this.$store.state.auth.userData.requiresChangePasswordOnLogin) {
        this.$router.push({ name: 'force-change-password' });
      } else {
        await this.getLoggedInUserPermissions();
      }
    } else {
      // Unauthenticated. this.$route can still be the START route here: the initial history
      // navigation for a lazy-loaded deep link resolves asynchronously, so this.$route.meta
      // isn't reliable yet. Detect public routes from the real URL and leave them untouched —
      // the set-password magic link and the /account-link consent page are opened by people
      // who can't sign in here; send anything else to the login form.
      const path = (window.location && window.location.pathname) || '';
      const isPublicRoute = path === '/'
        || /\/login(\/|$)/.test(path)
        || /\/account-link(\/|$)/.test(path);
      if (!isPublicRoute) {
        this.$router.push({ name: 'login-form' });
      }
    }

    // Fetch tenant settings
    this.$store.commit('changeShowLoader', true);
    try {
      const data = await accountService.getTenantSettings();
      this.$store.commit('changeTenantSettings', data);
      await this.bootstrapBranchContext();
      // Re-apply now that tenantSetting is loaded (covers the case where
      // userData has no preferredLanguage and we need the tenant default).
      this.applyEffectiveLanguage();
      try {
        const countries = await tenantService.getSupportedCountries(this.$i18n.locale);
        this.$store.commit('setSupportedCountries', countries);
      } catch (e) {
        // Phone fields fall back to libphonenumber + tenant default if this fails.
      }
    } catch (err) {
      this.showError(err, this.$t('errors.entities.page'), 'save');
    } finally {
      this.$store.commit('changeShowLoader', false);
    }
  },
  watch: {
    '$store.state.settings.tenantSetting.orgName': {
      immediate: true,
      handler() {
        if (this.$store.state.settings.tenantSetting && this.$store.state.settings.tenantSetting.orgName) {
          document.title = this.$store.state.settings.tenantSetting.orgName;
        } else {
          document.title = process.env.VUE_APP_DEFAULT_TITLE;
        }
      },
    },
  },
};
</script>

<style lang="scss" src="./scss-custom/general.scss"></style>
<style lang="scss">
.single-line {
  white-space: nowrap;
}

.to-left{
  text-align: left !important;
}
</style>
